import { enUS, fr, type Locale, nl, nlBE } from 'date-fns/locale';

import i18n from './i18n';

const dateFnsLocales: Record<string, Locale> = {
  en: enUS,
  'nl-NL': nl,
  'nl-BE': nlBE,
  fr: fr,
};

export const getDateFnsLocale = (): Locale => {
  const lang = i18n.language;

  return dateFnsLocales[lang] ?? enUS;
};
